module.exports = __webpack_public_path__ + "img/bcd30b6d.62a9eb05.png";